<section
  class="page-hero page-hero-developments page-hero-video-backed"
  aria-labelledby="developments-page-title"
>
  <video class="page-hero-video-bg" [autoplay]="true" [muted]="true" [loop]="true" playsinline>
    <source
      src="https://karimexclusives.b-cdn.net/Pavillion/mmTbMtaAg2KJWOMsvehndInUo.webm"
      type="video/webm"
    />
  </video>
  <div class="page-hero-video-shade"></div>
  <div>
    <h1 id="developments-page-title">Developments</h1>
  </div>
</section>

<section class="section page-section" aria-label="All developments">
  <div class="developments-heading">
    <h2>All properties</h2>
  </div>

  @if (propertiesLoading) {
    <div class="insights-state compact">
      <h3>Loading properties</h3>
      <p>Fetching properties from Django.</p>
    </div>
  } @else if (propertiesError) {
    <div class="insights-state compact">
      <h3>Properties are unavailable</h3>
      <p>Please check back shortly.</p>
    </div>
  } @else if (projects.length) {
    <div class="property-grid property-grid-page">
      @for (project of projects; track project.slug; let first = $first) {
        <article class="property-card" [class.feature-property]="first">
          <a
            class="property-media"
            href="#"
            [attr.aria-label]="'View ' + project.name + ' details'"
            (click)="selectProject($event, project.slug)"
          >
            @if (project.heroImage) {
              <img
                [src]="project.heroImage"
                [alt]="project.name + ' cover image'"
                (error)="useFallbackImage($event, project.heroFallbackImage)"
              />
            } @else {
              <div class="property-image-placeholder" aria-hidden="true"></div>
            }
            <span class="property-view">Details</span>
          </a>
          <div class="property-details">
            <div>
              @if (project.logoImage) {
                <img
                  class="property-logo"
                  [src]="project.logoImage"
                  [alt]="project.name"
                  (error)="useFallbackImage($event, project.logoFallbackImage)"
                />
              }
              <h3>{{ project.name }}</h3>
            </div>
            <p class="property-price">{{ project.price }}</p>
          </div>
        </article>
      }
    </div>
  } @else {
    <div class="insights-state compact">
      <h3>No live properties yet</h3>
      <p>Live properties from Django will appear here.</p>
    </div>
  }
</section>

<section class="section purchase-strip" aria-labelledby="purchase-title">
  <div>
    <h2 id="purchase-title">
      Reserve, structure your deposit, and move toward handover with clarity.
    </h2>
  </div>
  <button class="primary-button dark-button" type="button" (click)="inquiryRequested.emit()">
    Reserve unit
  </button>
</section>
